module.exports = __webpack_public_path__ + "fonts/PlayfairDisplay-Italic.4b3128e4.ttf";